import { EventBusy } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Delete from '@mui/icons-material/Delete';
import CancelIcon from '@mui/icons-material/Cancel';
import CheckIcon from '@mui/icons-material/Check';
import {
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Tooltip,
    Typography
} from '@mui/material';
import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import { red } from '@mui/material/colors';
import Skeleton from '@mui/material/Skeleton';
import { action, computed, makeObservable, observable, reaction } from 'mobx';
import { inject, observer } from 'mobx-react';
import moment from 'moment';
import { Fragment } from 'react';
import ErrorUtil from '../../util/ErrorUtil';
import NumeroProcesso from '../NumeroProcesso';
import PainelFiltros from '../PainelFiltros';
import ReactComponent from '../ReactComponent';
import FiltroRapido from './FiltroRapido';
import OperacoesEmLoteSelecionar from './OperacoesEmLoteSelecionar';
import PainelProcessosOperacoesEmLote from './PainelProcessosOperacoesEmLote';

class RemoverProcessosPautaLote extends ReactComponent {
    carregandoAlertas = false;
    dialogOpen = false;
    processosAlertas = [];
    carregado = false;
    dialogConfirmacaoOpen = false;

    constructor(props) {
        super(props);

        makeObservable(this, {
            carregandoAlertas: observable,
            dialogOpen: observable,
            processosAlertas: observable,
            carregado: observable,
            dialogConfirmacaoOpen: observable,
            handleClickIcone: action,
            handleCloseDialog: action,
            processos: computed,
            processosSelecionados: computed,
            processosComAlerta: computed,
            limparProcessoPesquisa: action,
            mensagemLoteSemProcessos: computed,
            handleClickBotaoRemover: action,
            handleClickBotaoRemoverConfirmação: action,
            handleCloseDialogConfirmacao: action,
            removerProcessosSelecionados: action,
            removerProcessoEmPauta: action,
            atualizarProcessosPautaveis: action,
            renderConteudoDialog: computed
        });

        this.createReaction(
            reaction(
                () => this.dialogOpen === true,
                () => {
                    this.carregado = false;
                    this.limparProcessoPesquisa();
                }
            )
        );
    }

    handleClickIcone = () => {
        this.dialogOpen = true;
    };

    handleCloseDialog = () => {
        this.dialogOpen = false;
    };

    get processos() {
        return this.pautaJulgamentoStore.origemPautaSelecionadaPJe
            ? (this.pautaJulgamentoStore.processosPautaSelecionadaFiltrados || []).filter(
                  (registro) => !registro.confirmadaInclusaoPauta && this.filtrarProcessoPeloNumero(registro)
              )
            : (this.pautaJulgamentoStore.processosPautaSelecionadaFiltrados || []).filter((registro) =>
                  this.filtrarProcessoPeloNumero(registro)
              );
    }

    get processosSelecionados() {
        return this.processosSelecionaveis.filter((registro) => this.store.isCheckedOperacoesEmLote(registro));
    }

    get processosComAlerta() {
        return this.processosSelecionados.filter((registro) => this.verificaAlertas(registro));
    }

    get processosSelecionaveis() {
        return this.processos;
    }

    limparProcessoPesquisa = () => {
        this.processoPesquisa = { numero: '', digito: '', ano: '', orgao: '', regional: '', vara: '' };
    };

    get mensagemLoteSemProcessos() {
        return 'Não há processos para remover da pauta' + this.complementoMensagemFiltrando;
    }

    handleClickBotaoRemover = () => {
        this.dialogConfirmacaoOpen = true;
    };

    handleClickBotaoRemoverConfirmação = async () => {
        this.dialogConfirmacaoOpen = false;
        await this.removerProcessosSelecionados();
    };

    handleCloseDialogConfirmacao = () => {
        this.dialogConfirmacaoOpen = false;
    };

    async removerProcessosSelecionados() {
        await this.pautaJulgamentoStore.processarLote({
            titulo: 'Removendo processos da pauta',
            qtdTotalProcessos: this.processosSelecionados.length,
            lotesProcessos: this.processosSelecionados,
            qtdPromisesParalelas: 1,
            funcaoOperacao: this.removerProcessoEmPauta
        });
        let promises = [];
        promises.push(this.sessaoStore.recarregarListaProcessos());
        promises.push(this.pautaJulgamentoStore.carregarProcessosPautaveis());
        await Promise.all(promises);
    }

    removerProcessoEmPauta = async (registro) => {
        let resultado = await this.processoService.removerProcessoPautaEmLote(
            this.pautaJulgamentoStore.idPautaSelecionada,
            registro,
            false
        );
        this.pautaJulgamentoStore.incrementarProgressoLote();
        return resultado;
    };

    atualizarProcessosPautaveis(resultadoProcessamento) {
        this.pautaJulgamentoStore.processosPautaveis = this.pautaJulgamentoStore.processosPautaveis.filter(
            (processoPautavel) => !this.isProcessoRetiradoComSucesso(resultadoProcessamento, processoPautavel)
        );
    }

    isProcessoRetiradoComSucesso(resultadoProcessamento, processoPautavel) {
        return (
            resultadoProcessamento.findIndex((resultado) => {
                if (resultado && !ErrorUtil.isResultadoErro(resultado)) {
                    return (
                        processoPautavel &&
                        processoPautavel.processo &&
                        processoPautavel.processo.numeroCompleto &&
                        processoPautavel.processo.numeroCompleto === resultado.numeroProcesso
                    );
                }

                return false;
            }) > -1
        );
    }

    verificaAlertas(processo) {
        return (
            processo.incluidoPeloGabinete ||
            processo.confirmadaPublicacaoPauta ||
            (!processo.confirmadaPublicacaoPauta && processo.confirmadaInclusaoPauta) ||
            processo.pedidoSustentacaoOral ||
            (this.validaData() <= 5 && this.validaData() > 0)
        );
    }

    dataMaior = () => {
        return parseInt(
            moment(this.pautaJulgamentoStore.pautaSelecionada.prazos.dataInicioSessaoPresencial, 'DD-MM-YYYY-HH-mm-ss')
                .startOf('day')
                .format('YYYYMMDDhhmmss')
        ) >
            parseInt(
                moment(
                    this.pautaJulgamentoStore.pautaSelecionada.prazos.dataInicioVotacaoVirtual,
                    'DD-MM-YYYY-HH-mm-ss'
                )
                    .startOf('day')
                    .format('YYYYMMDDhhmmss')
            )
            ? moment(this.pautaJulgamentoStore.pautaSelecionada.prazos.dataInicioVotacaoVirtual, 'DD-MM-YYYY-HH-mm-ss')
                  .startOf('day')
                  .format('YYYY-MM-DD')
            : moment(
                  this.pautaJulgamentoStore.pautaSelecionada.prazos.dataInicioSessaoPresencial,
                  'DD-MM-YYYY-HH-mm-ss'
              )
                  .startOf('day')
                  .format('YYYY-MM-DD');
    };

    validaData = () => {
        const d1 = moment().format('YYYY-MM-DD');
        const d2 = this.dataMaior();

        const difMs = new Date(d2) - new Date(d1);

        const difDias = difMs / (1000 * 60 * 60 * 24);
        return difDias;
    };

    render() {
        return (
            <Fragment>
                <div
                    style={{ marginRight: '10px' }}
                    className="corBotao"
                >
                    <Tooltip
                        title={'Remover processos em pauta em lote'}
                        placement="top-start"
                    >
                        <EventBusy
                            style={{ cursor: 'pointer', width: '24px', height: '24px' }}
                            onClick={this.handleClickIcone}
                        />
                    </Tooltip>
                </div>
                {this.dialogOpen && (
                    <Dialog
                        open
                        fullWidth
                        maxWidth="xl"
                        onClose={this.handleCloseDialog}
                        PaperProps={{ style: { height: '100%' } }}
                    >
                        {this.renderDialogTitle}
                        {this.renderConteudoDialog}
                        <DialogActions>
                            <Button
                                onClick={this.handleCloseDialog}
                                color="secondary"
                                variant="outlined"
                                endIcon={<CancelIcon />}
                            >
                                Fechar
                            </Button>
                            <Button
                                onClick={this.handleClickBotaoRemover}
                                color="primary"
                                variant="outlined"
                                endIcon={<Delete />}
                                disabled={
                                    this.carregandoAlertas ||
                                    !this.processosSelecionados ||
                                    this.processosSelecionados.length === 0
                                }
                            >
                                Remover
                            </Button>
                        </DialogActions>
                    </Dialog>
                )}
                {this.renderDialogConfirmacao()}
            </Fragment>
        );
    }

    renderConteudoConfirmacao() {
        const totalDiasParaSessao = this.validaData();
        const corAlerta = red[700];
        return (
            <div>
                {this.processosSelecionados.map((processo) => (
                    <Fragment key={this.nextKey}>
                        <div style={{ marginBottom: '5px' }}>
                            <Accordion expanded={this.verificaAlertas(processo) ? undefined : false}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1a-content"
                                    id="panel1a-header"
                                >
                                    <Typography
                                        style={{
                                            fontWeight: 'bold',
                                            color: this.verificaAlertas(processo) ? corAlerta : 'black'
                                        }}
                                    >
                                        {processo.processo.numeroCompleto}
                                    </Typography>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Typography>
                                        {processo.incluidoPeloGabinete === true && (
                                            <li style={{ color: corAlerta, marginBottom: '10px', fontSize: '15px' }}>
                                                <Typography
                                                    display={'inline'}
                                                    color={corAlerta}
                                                >
                                                    ATENÇÃO: Processo incluído na sessão.
                                                </Typography>
                                            </li>
                                        )}
                                        {processo.confirmadaPublicacaoPauta === true && (
                                            <li style={{ color: corAlerta, marginBottom: '10px', fontSize: '15px' }}>
                                                <Typography
                                                    display={'inline'}
                                                    color={corAlerta}
                                                >
                                                    ATENÇÃO: Processo publicado. Será necessário inserir edital no
                                                    processo sinalizando a remoção da pauta.
                                                </Typography>
                                            </li>
                                        )}
                                        {processo.confirmadaPublicacaoPauta !== true &&
                                            processo.confirmadaInclusaoPauta === true && (
                                                <li
                                                    style={{ color: corAlerta, marginBottom: '10px', fontSize: '15px' }}
                                                >
                                                    <Typography
                                                        display={'inline'}
                                                        color={corAlerta}
                                                    >
                                                        ATENÇÃO: Processo confirmado em pauta.
                                                    </Typography>
                                                </li>
                                            )}
                                        {totalDiasParaSessao <= 5 && totalDiasParaSessao > 0 && (
                                            <li style={{ color: corAlerta, marginBottom: '10px', fontSize: '15px' }}>
                                                <Typography
                                                    display={'inline'}
                                                    color={corAlerta}
                                                >
                                                    ATENÇÃO: Faltam {totalDiasParaSessao} dias para iniciar a sessão.
                                                </Typography>
                                            </li>
                                        )}
                                        {processo.pedidoSustentacaoOral && (
                                            <li style={{ color: corAlerta, marginBottom: '10px', fontSize: '15px' }}>
                                                <Typography
                                                    display={'inline'}
                                                    color={corAlerta}
                                                >
                                                    ATENÇÃO: Há 1 ou mais registros de inscrições de advogados neste
                                                    processo. Ao removê-lo da pauta, elas serão perdidas.
                                                </Typography>
                                            </li>
                                        )}
                                    </Typography>
                                </AccordionDetails>
                            </Accordion>
                        </div>
                    </Fragment>
                ))}
            </div>
        );
    }

    renderDialogConfirmacao() {
        return (
            this.dialogConfirmacaoOpen && (
                <Dialog
                    open
                    fullWidth
                    maxWidth="md"
                >
                    <DialogTitle>Remover processos em pauta/sessão</DialogTitle>
                    <DialogContent>
                        <Typography style={{ fontWeight: 'bold', marginBottom: '5px' }}>
                            Os seguintes processos serão removidos da pauta/sessão:
                        </Typography>
                        <li style={{ marginBottom: '10px' }}>
                            <Typography display="inline">Total de processos selecionados: </Typography>
                            {this.processosSelecionados.length}{' '}
                        </li>
                        <li style={{ marginBottom: '10px' }}>
                            <Typography display="inline">Total de processos com alertas: </Typography>
                            {this.processosComAlerta.length}{' '}
                        </li>
                        {this.renderConteudoConfirmacao()}
                    </DialogContent>
                    <DialogActions>
                        <Button
                            onClick={this.handleCloseDialogConfirmacao}
                            color="secondary"
                            variant="outlined"
                            endIcon={<CancelIcon />}
                        >
                            Fechar
                        </Button>
                        <Tooltip
                            placement="top-start"
                            title={'Remover processos da pauta/sessão'}
                        >
                            <div>
                                <Button
                                    onClick={this.handleClickBotaoRemoverConfirmação}
                                    color="primary"
                                    variant="outlined"
                                    endIcon={<CheckIcon />}
                                >
                                    Confirmar
                                </Button>
                            </div>
                        </Tooltip>
                    </DialogActions>
                </Dialog>
            )
        );
    }

    renderCarregando() {
        const skeleton = false;
        if (skeleton) {
            return (
                <Skeleton
                    variant="rectangular"
                    fullWidth
                    maxWidth="xl"
                    height="100%"
                    sx={{ m: 3 }}
                />
            );
        }
        return (
            <div style={{ display: 'flex', flexGrow: 1 }}>
                <CircularProgress
                    style={{ margin: '20px' }}
                    disableShrink={true}
                />
                <Typography
                    variant="h6"
                    style={{ margin: '25px 10px' }}
                >
                    Carregando processos
                </Typography>
            </div>
        );
    }

    get renderDialogTitle() {
        return (
            <DialogTitle style={{ padding: '16px 24px 0px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <div
                        style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            flexWrap: 'wrap',
                            flexGrow: 1
                        }}
                    >
                        <h4 style={{ margin: '0px' }}>Remover processos em pauta em lote</h4>
                        <div style={{ margin: '0px 10px' }}>
                            <NumeroProcesso
                                dense
                                tooltip="Número do processo a ser pesquisado na listagem"
                                callbackOnChange={this.callbackNumeroProcesso}
                                clickLimpar={this.limparProcessoPesquisa}
                            />
                        </div>
                        <div style={{ display: 'flex', alignItems: 'center' }}>
                            <div style={{ display: 'flex', alignItems: 'center', margin: '10px', paddingTop: '5px' }}>
                                <PainelFiltros />
                            </div>
                            <FiltroRapido id="filtroRapidoRemoverProcessosPautaLote" />
                        </div>
                    </div>
                </div>
            </DialogTitle>
        );
    }

    get renderConteudoDialog() {
        return this.sessaoStore.carregandoProcessos ? (
            <div style={{ display: 'flex', flexGrow: 1 }}>
                <CircularProgress
                    style={{ margin: '20px' }}
                    disableShrink={true}
                />
                <Typography
                    variant="h6"
                    style={{ margin: '25px 10px' }}
                >
                    Carregando processos
                </Typography>
            </div>
        ) : (
            <Fragment>
                <OperacoesEmLoteSelecionar
                    processosSelecionaveis={this.processosSelecionaveis}
                    processos={this.processos}
                />
                <PainelProcessosOperacoesEmLote
                    processos={this.processos}
                    mensagemLoteSemProcessos={this.mensagemLoteSemProcessos}
                    alertasProcessos={this.processosAlertas}
                />
            </Fragment>
        );
    }
}

export default inject('stores')(observer(RemoverProcessosPautaLote));
